import { Component, OnInit } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-order-public-view-submit',
  templateUrl: './order-public-view-submit.component.html',
  styleUrls: ['./order-public-view-submit.component.scss']
})
export class OrderPublicViewSubmitComponent implements OnInit {
  order_id: string;

  constructor(
    private location: LocationStrategy,
    private route: ActivatedRoute,


  ) {
     history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      if (params.get('id')) {
          // const decodedString = atob(params.get('date_slot'));

          this.order_id = params.get('id');
      }
  });

  }

}
